import React from "react"
import classes from "./ResultSet.module.css"
import Select from "react-select"
import { default_single_style, useLocalStorage } from "../../../Utils"
import { useTranslation } from "react-i18next"
import { defaultProfile, defaultNameplateData } from "../../../DefaultEntries"
import { get_nameplate_list, NamePlateBG } from "../../NamePlateBg/NamePlateBg"

const ControlInit = props => {
    const [t] = useTranslation()
    const [profile] = useLocalStorage("profile", defaultProfile)

    const default_nameplate = get_nameplate_list(profile.NamePlateBgMap)

    const [currentPulls, setCurrentPulls] = useLocalStorage(
        `finder_${props.localKey}`,
        defaultNameplateData(default_nameplate[0])
    )

    const changePull = (val, idx) => {
        const new_arr = [...currentPulls]
        new_arr[idx] = val
        setCurrentPulls(new_arr)
    }

    const changeNameplate = (elem, idx) => {
        changePull({ ...currentPulls[idx], Value: elem }, idx)
    }

    const addEntry = () => {
        const new_arr = [...currentPulls]
        new_arr.push({ Num: currentPulls.length + 1, Value: default_nameplate[0] })
        setCurrentPulls(new_arr)
    }

    const removeEntry = () => {
        const new_arr = [...currentPulls]
        new_arr.pop()
        setCurrentPulls(new_arr)
    }

    return (
        <div className={classes.WrapperNoScroll}>
            <div className={classes.Gap}></div>
            <div className={classes.ButtonArea}>
                <button className={classes.Button} disabled={currentPulls.length === 1} onClick={removeEntry}>
                    -
                </button>
                <span style={{ marginRight: 15 }}>{t("misc:SeedListing.Pull")}</span>
                <button className={classes.Button} onClick={addEntry}>
                    +
                </button>
            </div>
            {currentPulls.map((entry, idx) => {
                return (
                    <Entry
                        num={entry.Num}
                        key={entry.Num}
                        onChange={changeNameplate}
                        idx={idx}
                        value={currentPulls[idx].Value}
                    />
                )
            })}
            <div className={classes.ButtonArea}>
                <button className={classes.Button} disabled={currentPulls.length === 1} onClick={removeEntry}>
                    -
                </button>
                <span style={{ marginRight: 15 }}>{t("misc:SeedListing.Pull")}</span>
                <button className={classes.Button} onClick={addEntry}>
                    +
                </button>
            </div>
            <div className={classes.Gap}></div>
            <div className={classes.ButtonArea}>
                <button className={classes.Button} onClick={() => props.findSeed(currentPulls)}>
                    {t("misc:Recovery.ButtonSearch")}
                </button>
            </div>
        </div>
    )
}

const Entry = props => {
    const [profile] = useLocalStorage("profile", defaultProfile)

    const [t] = useTranslation()
    const default_nameplate = get_nameplate_list(profile.NamePlateBgMap)
    const ss = default_single_style()

    return (
        <div className={classes.PullEntry}>
            <div className={classes.PullHeader}>
                {props.num}. {t("translation:CommonMsg.Glossary.NamePlateBg")}
            </div>
            <Select
                defaultValue={default_nameplate[0]}
                name="nameplates"
                options={default_nameplate}
                value={props.value}
                styles={ss}
                onChange={elem => props.onChange(elem, props.idx)}
                formatOptionLabel={elem => {
                    return <NamePlateBG elem={elem.raw} formless={true} />
                }}
            />
        </div>
    )
}

export default ControlInit
